import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import { Provider, ErrorBoundary } from "@rollbar/react";
import { rollbarConfigV2 } from "./utils";
import { Workbox } from "workbox-window";
import { BASE_SUB_PATH } from "./sw-const";

const ErrorDisplay = (
  { error, resetError } // <-- props passed to fallbackUI component
) => (
  <div>
    <h1>Error</h1>
    <div>{error.toString()}</div>
    <br />
    <div>
      <a
        style={{ color: "blue" }}
        href="/patient"
        onClick={() => localStorage.clear()}
      >
        Go to home page
      </a>
    </div>
  </div>
);

ReactDOM.render(
  <React.StrictMode>
    <Provider config={rollbarConfigV2}>
      <ErrorBoundary fallbackUI={ErrorDisplay}>
        <App />
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

if ("serviceWorker" in navigator) {
  const wb = new Workbox(`${BASE_SUB_PATH}/service-worker.js`);

  wb.addEventListener("waiting", () => {
    // ask user with native prompt
    const ok = window.confirm("A new version is available — reload now?");
    if (!ok) return;

    navigator.serviceWorker.addEventListener(
      "controllerchange",
      () => {
        window.location.reload();
      },
      { once: true }
    );

    wb.messageSW({ type: "SKIP_WAITING" }).catch((err) => {
      console.error("messageSW failed", err);
      window.location.reload();
    });
  });

  wb.register().catch((e) => console.error("SW register failed", e));
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
